<template>
    <div class="flats-crm-items-container flats-items-grid" v-if="flatsItems != null">
        <div class="flats-empty-msg" v-if="flatsEmptyMsg"><p>По данному запросу квартир в продаже не найдено</p></div>
        <div class="flats-items" v-if="!flatsEmptyMsg">
            <div class="flat-item" v-for="item in flatsItems" :key="item.id">
                <a href="#" @click.prevent="openCrmFlatModal(item)">
                    <div class="item-default item-img" v-if="item != null && item.id != null">
                        <div class="img-in" v-if="item.images.length > 0">
                            <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" alt="" v-for="pic in item.images" v-if="pic.typeCode == '1'">
                        </div>
                    </div>
                    <div class="item-desc">
                        <div class="item-title">
                            <span>{{item.rooms}}<b v-if="item.rooms != 1">-x</b></span> комнатная, {{item.area}}м²
                        </div>
                        <div class="item-info">
                            <ul>
                                <li>
                                    <div class="left">
                                        Комнат
                                    </div>
                                    <div class="right">
                                        {{item.rooms}}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        Этаж
                                    </div>
                                    <div class="right">
                                        {{item.floor}}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        Площадь
                                    </div>
                                    <div class="right">
                                        {{item.area}} <span>м²</span>
                                    </div>
                                </li>
                                <li class="price" v-if="setup.site_price_flats_init == 'true' && item.showPricesOnSaleSite == true">
                                    <div class="left">
                                        Цена м²
                                    </div>
                                    <div class="right">
                                        <span>от</span> {{getNumber(item.meterPrice)}} <span>тыс.тг</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        Номер кв.
                                    </div>
                                    <div class="right">
                                        {{item.number}}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        <span>Пятно</span>
                                    </div>
                                    <div class="right">
                                        {{getNumbersOfBlockMNC(item.blockName)}}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        <span>Очередь</span>
                                    </div>
                                    <div class="right">
                                        {{ getNumbersOfBlockPartMNC(item.blockName) }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </a>
                <div class="item-btns" v-if="setup.site_online_booking_init == 'true'">
                    <a :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=book'" class="bron" target="_blank" 
                        v-if="item.isApartmentReserved"
                        >Забронировать
                    </a>
                    <span v-else class="btn-off bron-off">Забронировать</span>
                    <a :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=by'" class="by" target="_blank" 
                        v-if="item.hasJointVentureAgreement"
                        >Купить
                    </a>
                    <span v-else class="btn-off by-off">Купить</span>
                </div>
                <!-- <a href="#" class="getPrice" @click.prevent="openFormModal(true)">ЗАПРОСИТЬ ЦЕНУ</a> -->
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-item',
        components: {
        },
        data () {
            return {
            }
        },
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlock(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlockMNC(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getNumbersOfBlockPartMNC(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            openCrmFlatModal(arr) {
                this.$store.commit('modalData', arr);
                setTimeout(() => {
                    this.$modal.show('sales_land_flat_card_crm_modal');
                }, 300);
            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            openFormModal(param) {
                this.$store.commit('Open_Form_Modal', param);
            },
            checkConfirmPurchase(param, code, blockNameStr) {
                var blockName = parseInt(this.getNumbersOfBlockMNC(blockNameStr));
                var blockPart = this.getNumbersOfBlockPartMNC(blockNameStr);
                // console.log(blockNameStr, blockName, blockPart)
                if (param == 'book') {
                    if (blockName == '5') {
                        if (blockPart == 'Б-С5-1') {
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else if (param == 'by') {
                    if (blockName == '5') {
                        if (blockPart == 'Б-С5-1') {
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.flatsPage,
            //     (newValue) => {
            //         if (newValue) {
            //            this.filterSize();
            //             this.filterFloor();
            //         }
            //     }
            // );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items.scss';
    @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-respond.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>